export const API_URL = 'https://chachi-api.justcompileit.com/v1'